module.exports = __webpack_public_path__ + "img/belun-square.1ed7d5fd.png";